import React from "react";
import { SEVERITY_TONE } from "@/components/brand/StatusBadge";

// Severity is always shown as TEXT plus a dot, never colour alone. Colours are the brand status tokens.
export const SEVERITY = {
  threat: { label: "Threat", help: "Tries to make the agent do something harmful" },
  warning: { label: "Warning", help: "Worth knowing, not an attack" },
  info: { label: "Info", help: "Context for research, e.g. the server needs an API key" },
  none: { label: "None", help: "No signals" },
};

export default function SeverityBadge({ severity }) {
  const key = SEVERITY[severity] ? severity : "none";
  const s = SEVERITY[key];
  return (
    <span data-testid="severity-badge" data-severity={key} title={s.help}
          className={`hs-badge hs-badge-${SEVERITY_TONE[key]}`}>{s.label}</span>
  );
}
